import React from 'react';
import { CheckIcon, ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from './MetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="pricing" className="py-12 sm:py-20 bg-white relative overflow-hidden" data-id="element-184">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-185"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-7xl" data-id="element-186">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border border-orange-100" data-id="element-187">
          <div className="bg-rose-500 p-4 sm:p-6 text-center text-white" data-id="element-188">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2" data-id="element-189">
              Tu cocina puede sentirse diferente esta noche
            </h2>
            <p className="opacity-90 text-sm sm:text-base" data-id="element-190">
              Obtén acceso inmediato a todo el sistema
            </p>
          </div>

          <div className="p-4 sm:p-8 lg:p-12 grid md:grid-cols-2 gap-8 sm:gap-12" data-id="element-191">
            {/* Left Column: Summary */}
            <div className="space-y-4 sm:space-y-6" data-id="element-192">
              <div className="space-y-3 sm:space-y-4" data-id="element-193">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-194">
                  ¿Qué incluye tu orden?
                </h3>
                <ul className="space-y-2 sm:space-y-3" data-id="element-195">
                  {['Libro Digital: 50 Recetas en 5 Minutos', 'Bono #1: Planificador Semanal', 'Bono #2: Lista Inteligente de Compras', 'Bono #3: 10 Recetas de Emergencia', 'Bono #4: Postres Virales en 1 Página', 'Acceso de por vida', 'Actualizaciones futuras gratis'].map((item, idx) => <li key={idx} className="flex items-start gap-2 sm:gap-3 text-gray-700" data-id="element-196">
                      <div className="bg-green-100 p-1 rounded-full text-green-600 flex-shrink-0 mt-0.5" data-id="element-197">
                        <CheckIcon className="w-3 h-3" data-id="element-198" />
                      </div>
                      <span className="text-xs sm:text-sm font-medium leading-relaxed" data-id="element-199">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-orange-50 p-3 sm:p-4 rounded-xl border border-orange-100 flex gap-2 sm:gap-3 items-start" data-id="element-200">
                <ShieldCheckIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-201" />
                <div data-id="element-202">
                  <h4 className="font-bold text-gray-800 text-xs sm:text-sm" data-id="element-203">
                    Garantía tranquila
                  </h4>
                  <p className="text-[10px] sm:text-xs text-gray-600 mt-1" data-id="element-204">
                    Si no te funciona, te devolvemos cada centavo. Sin
                    preguntas, sin formularios, sin drama.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Price & CTA */}
            <div className="flex flex-col items-center bg-gray-50 p-4 sm:p-8 rounded-xl sm:rounded-2xl border border-gray-100" data-id="element-205">
              <div className="flex justify-center w-full mb-3 sm:mb-4" data-id="element-206">
                <CountdownBadge data-id="element-207" />
              </div>

              <div className="my-4 sm:my-6 w-full flex justify-center" data-id="element-208">
                <CountdownTimer data-id="element-209" />
              </div>

              <div className="mt-4 sm:mt-6 mb-2 text-center w-full" data-id="element-210">
                <span className="text-gray-400 line-through text-lg sm:text-xl font-medium" data-id="element-211">
                  $29.99 USD
                </span>
              </div>
              <div className="flex items-start justify-center gap-1 mb-4 sm:mb-6 w-full" data-id="element-212">
                <span className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1 sm:mt-2" data-id="element-213">
                  $
                </span>
                <span className="text-5xl sm:text-7xl font-bold text-rose-500 tracking-tighter" data-id="element-214">
                  11.99
                </span>
                <span className="text-lg sm:text-xl font-bold text-gray-900 mt-1 sm:mt-2" data-id="element-215">
                  USD
                </span>
              </div>

              <div className="w-full flex flex-col items-center" data-id="element-216">
                <a href="https://pay.hotmart.com/S103786789F?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full bg-rose-500 hover:bg-rose-600 text-white text-base sm:text-lg font-bold py-3 sm:py-4 rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 group animate-button-pulse mb-3" data-id="element-217">
                  <span data-id="element-218">Quiero cocinar sin pensar</span>
                  <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-219" />
                </a>

                <p className="text-green-600 font-bold text-sm mb-3 sm:mb-4 text-center w-full" data-id="element-220">
                  Ahorro de $17.99
                </p>
              </div>

              <p className="text-[10px] sm:text-xs text-gray-500 text-center w-full mb-3 sm:mb-4" data-id="element-221">
                Es un PDF. Lo descargás, lo abrís y empezás. Así de simple.
              </p>

              <div className="flex gap-2 justify-center mt-2 sm:mt-4 opacity-50 grayscale w-full flex-wrap" data-id="element-222">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-3 sm:h-4" data-id="element-223" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-3 sm:h-4" data-id="element-224" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png" alt="PayPal" className="h-3 sm:h-4" data-id="element-225" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}